import TtamAudienceSizeMainTitle from './main-title/index.vue';
import TtamAudienceSizeEstimateChart from './estimate-chart/index.vue';
import TtamAudienceSizeEstimateNum from './estimate-num/index.vue';
import TtamAudienceSizeTargetExpansionTip from './target-expansion-tip/index.vue';
import TtamAudienceSizeImpressionTip from './impression-tip/index.vue';
import TtamAudienceSizeLocationTip from './location-tip/index.vue';
import TtamAudienceSizeClaTip from './cla-tip/index.vue';
import TtamAudienceSizeAgeTip from './age-tip/index.vue';
import TtamAudienceSizeNarrowTip from './narrow-tip/index.vue';
import TtamAudienceSizeBroadTip from './broad-tip/index.vue';
import TtamAudienceSizeTtpTip from './ttp-tip/index.vue';
import TtamAudienceSizePangleRetargetingTip from './pangle-retargeting-tip/index.vue';
import {
  usePropsAgeTipVisible,
  usePropsBroadTipVisible,
  usePropsLocationTipVisible,
  usePropsNarrowTipVisible,
  usePropsTargetExpansionTipVisible,
  usePropsTtpTipVisible,
  usePropsImpressionTipVisible,
  usePropsPangleRetargetingTipVisible,
  usePropsEstimateFail,
  usePropsTtpUnsupportedArea,
  useTtpCloverUnsupportedTips,
  usePropsEstimateCount,
  useDataSource,
  usePropsTipVisible,
} from './hooks';

export default {
  TtamAudienceSizeMainTitle,
  TtamAudienceSizeEstimateChart,
  TtamAudienceSizeEstimateNum,
  TtamAudienceSizeTargetExpansionTip,
  TtamAudienceSizeImpressionTip,
  TtamAudienceSizeLocationTip,
  TtamAudienceSizeClaTip,
  TtamAudienceSizeAgeTip,
  TtamAudienceSizeNarrowTip,
  TtamAudienceSizeBroadTip,
  TtamAudienceSizeTtpTip,
  TtamAudienceSizePangleRetargetingTip,
  usePropsAgeTipVisible,
  usePropsBroadTipVisible,
  usePropsLocationTipVisible,
  usePropsNarrowTipVisible,
  usePropsTargetExpansionTipVisible,
  usePropsTtpTipVisible,
  usePropsImpressionTipVisible,
  usePropsPangleRetargetingTipVisible,
  usePropsEstimateFail,
  usePropsTtpUnsupportedArea,
  useTtpCloverUnsupportedTips,
  usePropsEstimateCount,
  useDataSource,
  usePropsTipVisible,
};
